module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon05.2551c285.svg";